import React from "react";
import "./FiestaMedalTile.css";
import medalImg from "../images/sign1.jpg";
import qrImg from "../images/payhubQR.png";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

const FiestaMedalTile = () => {
  return (
    <div className="fiesta-banner">
  <div className="fiesta-left">
    <img src={medalImg} alt="ASL Fiesta Medal" className="fiesta-medal-img" />
  </div>

  <div className="fiesta-center">
    <h2>🤟 ASL Fiesta Medal 2025 🖐️✋👐</h2>
    <h2>Collect It. Flaunt It. Support Local.</h2>
    <p className="fiesta-subtitle">
      Celebrate inclusion, culture, and community with style!
    </p>
    <Link to="/fiesta" className="learn-more-btn">Learn More →</Link>
  </div>

  <div className="fiesta-qr-right">
    <img src={qrImg} alt="QR Code" className="qr-code-img" />
    <a
      href="https://pay.goourhub.com"
      className="scan-btn"
      target="_blank"
      rel="noopener noreferrer"
    >
      📷 Scan & Save $2
    </a>
    <a
      href="https://pay.goourhub.com"
      className="order-now"
      target="_blank"
      rel="noopener noreferrer"
    >
      Order Now
    </a>
  </div>
</div>

    
    
  );
};

export default FiestaMedalTile;
